import { makeStyles } from "@material-ui/core/styles";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Switch } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import WidthCard from "./WidthCard";
import RelativeScaleSlider from "../../Signet/Studio/components/RelativeScaleSlider";
import RelativePaddingSlider from "../../Signet/Studio/components/RelativePaddingSlider";

const useStyles = makeStyles((theme) => ({
  profileAccordion: {
    marginBottom: theme.spacing(2),
    '&:before': {
      display: 'none',
    },
    backgroundColor: theme.palette.background.default,
  },
  profileAccordionSummary: {
    padding: theme.spacing(0, 2),
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  profileHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  profileControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: 1,
  },
  profileName: {
    textTransform: 'capitalize',
    fontWeight: 500,
    textAlign: 'center',
  },
  widthsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    width: '100%',
  },
}));

const ProfileWidthAccordion = ({
  profile,
  expanded,
  profileConfig,
  onAccordionChange,
  onProfileToggle,
  onWidthToggle,
  onProfileScaleChange,
  onProfilePaddingChange,
  onWidthScaleChange,
  onWidthPaddingChange,
  onShadowChange,
  onRotationChange,
  onWarpChange,
  onDisplacementChange,
  onPositionChange,
  onManualWarpToggle,
  onManualWarpUpdate,
  configSwitchLabel
}) => {
  const classes = useStyles();

  return (
    <Accordion
      expanded={expanded === profile.id && profile.checked}
      onChange={onAccordionChange(profile)}
      className={classes.profileAccordion}
    >
      <AccordionSummary expandIcon={profile.checked && <ExpandMoreIcon />} className={classes.accordionSummary}>
        <div className={classes.profileHeader}>
          <div className={classes.profileControls}>
            <Switch
              checked={profile.checked}
              onChange={(e) => onProfileToggle(profile.id, e.target.checked)}
              color="primary"
            />
            <Typography className={classes.profileName}>{profile.name}</Typography>
          </div>

          <div className={classes.profileControls}>
            <RelativeScaleSlider
              mappingParam={profile}
              paramConfig={profileConfig}
              onScaleChange={onProfileScaleChange}
              param='profile'
              disabled={!profile.checked}
              configSwitchLabel={configSwitchLabel}
            />
            <RelativePaddingSlider
              mappingParam={profile}
              paramConfig={profileConfig}
              onPaddingChange={onProfilePaddingChange}
              param='profile'
              disabled={!profile.checked}
              configSwitchLabel={configSwitchLabel}
            />
          </div>
        </div>
      </AccordionSummary>

      <AccordionDetails>
          <div className={classes.widthsGrid}>
            {profile?.children?.map((width) => {
              return (
                <WidthCard
                  key={width.id}
                  width={width}
                  profile={profile}
                  widthConfig={profileConfig?.[width.sku_code]?.config[configSwitchLabel]}
                  profileEnabled={profile.checked}
                  onWidthToggle={onWidthToggle}
                  onScaleChange={onWidthScaleChange}
                  onPaddingChange={onWidthPaddingChange}
                  onShadowChange={onShadowChange}
                  onRotationChange={onRotationChange}
                  onWarpChange={onWarpChange}
                  onDisplacementChange={onDisplacementChange}
                  onPositionChange={onPositionChange}
                  onManualWarpToggle={onManualWarpToggle}
                  onManualWarpUpdate={onManualWarpUpdate}
                />
              );
            })}
          </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default ProfileWidthAccordion;